// initial state
const state = {
  themeColor: '249CE6',
  openAccess: '1',
  fixedToolNav: 0,
  fixedToolQrcode: 0
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  changeThemeColor (state, themeColor) {
    state.themeColor = themeColor
  },
  changeOpenAccess (state, openAccess) {
    state.openAccess = openAccess
  },
  changeFixedToolNav (state, fixedToolNav) {
    state.fixedToolNav = fixedToolNav
  },
  changeFixedToolQrcode (state, fixedToolQrcode) {
    state.fixedToolQrcode = fixedToolQrcode
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js